import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ui from 'redux-ui';
import { connect } from 'react-redux';
import Loading from 'components/Loading';
import MessageBox from 'components/MessageBox';
import WorkroomCard from './components/workroomCard';
import { requestWorkroomList } from 'actionCreators';
import { getWorkroomList, getWorkroomLoading } from '../../../../reducers';

class WorkroomList extends Component {
  static propTypes = {
    ui: PropTypes.object,
    loading: PropTypes.bool,
    needsMore: PropTypes.bool,
    workrooms: PropTypes.array,
    updateUI: PropTypes.func,
    dispatch: PropTypes.func,
    requestWorkroomList: PropTypes.func,
  }

  componentDidMount() {
    this.props.requestWorkroomList();
  }

  componentWillUnmount() {
    if (this.props.ui.successMessage) {
      this.props.updateUI('successMessage', '');
    }
  }

  render() {
    const { workrooms, loading } = this.props;

    return (
      <div>
        {this.props.ui.successMessage && <MessageBox message={this.props.ui.successMessage} />}
        {loading && <Loading message="Loading workrooms..." />}
        {workrooms.map(workroom => (
          <WorkroomCard
            key={workroom.id}
            workroom={workroom}
          />
        ))}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const workrooms = getWorkroomList(state);
  const loading = getWorkroomLoading(state);
  return {
    loading,
    workrooms,
  };
};

export default ui()(connect(
  mapStateToProps, { requestWorkroomList },
)(WorkroomList));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/workrooms/workroomList.jsx